import Styles from './assets/reportContainerStyles.scss';
import { ReportDesigner, ReportViewer } from './components';
import { IReportDesignerProps, IReportViewerProps } from './entities';

import '../common/assets/devextreme/generic/dx.generic.module.css';
import '../common/assets/devextreme/generic/reset.module.css';

import 'ace-builds/css/ace.css';
import 'ace-builds/css/theme/dreamweaver.css';
import 'ace-builds/css/theme/ambiance.css';
import '@devexpress/analytics-core/dist/css/dx-analytics.common.css';
import '@devexpress/analytics-core/dist/css/dx-analytics.light.css';
import '@devexpress/analytics-core/dist/css/dx-querybuilder.css';
import 'devexpress-reporting/dist/css/dx-webdocumentviewer.css';
import 'devexpress-reporting/dist/css/dx-reportdesigner.css';

function BCReportViewer(props: IReportViewerProps) {
	return (
		<div className={Styles.reportContainerStyles}>
			<ReportViewer {...props} />
		</div>
	);
}

function BCReportDesigner(props: IReportDesignerProps) {
	return (
		<div className={Styles.reportContainerStyles}>
			<ReportDesigner {...props} />
		</div>
	);
}

export { BCReportDesigner, BCReportViewer };
